module.exports = __webpack_public_path__ + "img/11_uk.91572c19.svg";